/* Created by Interactive 63 - https://interactive63.com */
/**
 * The small "JS" tag shown beside settings that only work when the export includes the
 * JavaScript runtime.
 */
import { h } from './dom';

export const JS_BADGE_TITLE = 'Needs the JavaScript runtime. Export as CSS + JS.';

export const MORPH_JS_TITLE =
  'Morphing in every browser needs the JavaScript runtime. Export as CSS + JS.';

/** A badge marking an option that depends on the JavaScript runtime. */
export function jsBadge(title: string = JS_BADGE_TITLE): HTMLElement {
  return h('span', { class: 'js-badge', title }, 'JS');
}
